import { Card, MultiSelect, TextInput } from 'corso-admin-ui';
import { Controller } from 'react-hook-form';
import { useProductFormContext } from '~/features/products/ProductForm';
import { useProduct } from '~/features/products/ProductProvider';
import { useProductTags } from '~/features/settings/hooks/useProductTags';

const toOption = (name: string) => ({ value: name, label: name });

function NullableTextInput({
  id,
  label,
  name,
  disabled,
}: {
  id: string;
  label: string;
  name: 'productType' | 'vendor';
  disabled: boolean;
}) {
  const { control } = useProductFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange, ...field }, fieldState }) => (
        <TextInput
          id={id}
          label={label}
          disabled={disabled}
          {...field}
          value={value ?? ''}
          onChange={(event) => onChange(event.target.value || null)}
          error={fieldState.error?.message}
        />
      )}
    />
  );
}

export function ProductOrganization() {
  const product = useProduct();
  const { control } = useProductFormContext();
  const { data: tags = [] } = useProductTags();
  const isReadOnly = !product.isOffPlatform;

  return (
    <Card>
      <Card.Line>
        <Card.Heading>Organization</Card.Heading>
      </Card.Line>

      <NullableTextInput
        id="product-type"
        label="Type"
        name="productType"
        disabled={isReadOnly}
      />
      <NullableTextInput
        id="product-vendor"
        label="Vendor"
        name="vendor"
        disabled={isReadOnly}
      />

      {isReadOnly ? (
        <TextInput
          id="product-tags"
          label="Tags"
          disabled
          value={product.tags?.join(', ') ?? ''}
        />
      ) : (
        <Controller
          control={control}
          name="tags"
          render={({ field: { value, onChange }, fieldState }) => (
            <MultiSelect
              creatable
              label="Tags"
              placeholder="Add Tag"
              options={tags.map(({ name }) => toOption(name))}
              value={value.map(toOption)}
              onChange={(options) => onChange(options.map((o) => o.value))}
              error={fieldState.error?.message}
            />
          )}
        />
      )}
    </Card>
  );
}
